/** Cancel the in-flight agent turn for a conversation, if any */
export const agentConversationCancelSpec = {
    uri: '/agent/conversation/[conversation]/cancel',
    method: 'POST',
    adminOnly: true,
};
